var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-flex tw-text-center"},[_c('div',[_c('iframe',{staticStyle:{"border":"0"},attrs:{"width":"1150","height":"800","src":_vm.embedUrl,"frameborder":"0","allowfullscreen":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }